import _each from "lodash/each";
import snaptr from "web/script/embedded/snapchat";

export default {
    pixelId: "932e622e-76d4-48fc-a5c6-e0712b9cdac8",

    init: function (analytics) {
        var snapchatHash = analytics.getSnapchatHash();
        snaptr("init", this.pixelId, { user_hashed_email: snapchatHash });
    },

    send: function (data) {
        _each(data, (event) => {
            // only deal with snapchat_events
            if (event.type !== "snapchat_event") {
                return;
            }
            var track = event.data;
            snaptr("track", track.eventName, track.customData || {});
        });

        return Promise.resolve();
    },
};
